<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
      <template v-for="(item, index) in leaveMessageConfigList">
        <!-- 单行文本 -->
        <a-form-item
          v-if="item.fieldType == 4"
          :key="index"
          :label="item.fieldName"
        >
          <a-input
            v-decorator="[
              item.key,
              {
                rules: [
                  {
                    required: item.required === 1,
                    message: `${$t('pleaseEnter')}${item.fieldName}`,
                  },
                  { validator: item.validatorFn },
                ],
              },
            ]"
            :placeholder="`${$t('pleaseEnter')}${item.fieldName}`"
          />
        </a-form-item>
        <!-- 时间选框 -->
        <a-form-item
          v-else-if="item.fieldType == 3"
          :key="index"
          :label="item.fieldName"
        >
          <timeGroup
            v-decorator="[
              item.key,
              {
                rules: [
                  {
                    required: item.required === 1,
                    message: `${$t('pleaseSelect')}${item.fieldName}`,
                  },
                ],
                initialValue: '08:30 - 18:00',
              },
            ]"
          />
        </a-form-item>
        <!-- 单选框 -->
        <a-form-item
          v-else-if="item.fieldType == 1"
          :key="index"
          :label="item.fieldName"
        >
          <a-select
            :placeholder="`${$t('pleaseEnter')}${item.fieldName}`"
            v-decorator="[
              item.key,
              {
                rules: [
                  {
                    required: item.required === 1,
                    message: `${$t('pleaseSelect')}${item.fieldName}`,
                  },
                ],
              },
            ]"
          >
            <a-select-option
              v-for="(v, k) in item.options"
              :key="k"
              :value="v"
              >{{ v }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <!-- 多行文本 -->
        <a-form-item
          v-else-if="item.fieldType == 5"
          :key="index"
          :label="item.fieldName"
        >
          <a-textarea
            :placeholder="`${$t('pleaseEnter')}${item.fieldName}`"
            v-decorator="[
              item.key,
              {
                rules: [
                  {
                    required: item.required === 1,
                    message: `${$t('pleaseEnter')}${item.fieldName}`,
                  },
                  { validator: item.validatorFn },
                ],
              },
            ]"
          />
        </a-form-item>
        <!-- 多选框 -->
        <a-form-item
          v-else-if="item.fieldType == 2"
          :key="index"
          :label="item.fieldName"
        >
          <a-checkbox-group
            v-decorator="[
              item.key,
              {
                rules: [
                  {
                    required: item.required === 1,
                    message: `${$t('pleaseSelect')}${item.fieldName}`,
                  },
                ],
              },
            ]"
          >
            <a-checkbox v-for="(v, k) in item.options" :key="k" :value="v">{{
              v
            }}</a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <!-- 上传文件 -->
        <a-form-item
          v-else-if="item.fieldType == 6"
          :key="index"
          :label="item.fieldName"
        >
          <uploadForm
            v-decorator="[
              item.key,
              {
                rules: [
                  {
                    required: item.required === 1,
                    message: `${$t('pleaseSelect')}${item.fieldName}`,
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <!-- <a-form-item :key="index" :label="item.fieldName">
          <uploadForm v-decorator="[item.key, {rules: [{required: item.required === 1, message: `${$t('pleaseSelect')}${item.fieldName}`}]}]" />
        </a-form-item> -->
      </template>
      <a-form-item v-if="isShowSubmit" :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" :loading="btnLoading" @click="submit">{{
          $t("OK")
        }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import ajax from "@/ajax/axios-ajax.js";
import apis from "@/apis/index.js";
import timeGroup from "./time-group.vue";
import uploadForm from "./upload-form.vue";
import regular from "@/common/js/regular";
import { mapState } from "vuex";
export default {
  props: ["isShowSubmit", "isCloseWindow"],
  computed: {
    ...mapState({
      visitorInfo: "visitorInfo",
      leaveType: "leaveType",
    }),
  },
  components: {
    timeGroup,
    uploadForm,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: {
          xs: {
            span: 24,
          },
          sm: {
            span: 4,
          },
        },
        wrapperCol: {
          xs: {
            span: 24,
          },
          sm: {
            span: 20,
          },
        },
      },
      leaveMessageConfigList: [],
      btnLoading: false,
      lang: "zh",
      leaveMessageFormConfigList: [],
    };
  },
  methods: {
    submit() {
      this.form.validateFields((err, values) => {
        if (err) {
          return false;
        }
        this.sureSubmit(values);
      });
    },
    // 设置留言配置
    setConfigList(configList) {
      configList.forEach((ev, index) => {
        ev.key = "a" + index;
        this.$set(ev, "selectedValue", "");
        if (ev.fieldType === 2) {
          // 多选框
          this.$set(ev, "selectedValue", []);
          ev.options = ev.fieldValue ? ev.fieldValue.split(",") : [];
        } else if (ev.fieldType == 1) {
          // 单选框
          ev.options = ev.fieldValue ? ev.fieldValue.split(",") : [];
        } else {
        }
        ev.validatorFn = (rule, value, callback) => {
          if (!value) {
            callback();
            return false;
          }
          // 特殊验证
          let iphoneRegular = {
            // 电话号码
            isOpen: ev.isPhone === 1,
            regular: regular.isPhone, // 是否是电话号码
            message: this.$t("enterCorrectPhone"),
            keyWord: this.$t("phoneFormat"),
          };
          if (iphoneRegular.isOpen) {
            if (!iphoneRegular.regular.test(value)) {
              callback(iphoneRegular.message);
              return false;
            }
          }
          let emilRegular = {
            // 邮箱
            isOpen: ev.isEmil === 1,
            regular: regular.isEmil, // 是否是邮箱
            message: this.$t("enterCorrectEmail"),
            keyWord: this.$t("emailFormat"),
          };
          if (emilRegular.isOpen) {
            if (!emilRegular.regular.test(value)) {
              callback(emilRegular.message);
              return false;
            }
          }
          // 需要正则验证的数组
          let regularArr = [
            {
              isOpen: ev.isNumber === 1,
              regular: regular.isNumber, // 是否是数字
              search: regular.searchNumber,
              message: this.$t("enterNum"),
              keyWord: this.$t("number"),
            },
            {
              isOpen: ev.isEnglish === 1,
              regular: regular.isEnglish, // 是否是英文
              search: regular.searchEnglish,
              message: this.$t("enterEnglish"),
              keyWord: this.$t("english"),
            },
            {
              isOpen: ev.isChinese === 1, // 是否是中文
              regular: regular.isChinese, // 是否是中文
              search: regular.searchChinese,
              message: this.$t("enterChinese"),
              keyWord: this.$t("chinese"),
            },
            {
              isOpen: ev.isChar === 1, // 是否是中文
              regular: regular.isChar, // 是否是中文
              search: regular.searchChar,
              message: this.$t("enterSpecial"),
              keyWord: this.$t("special"),
            },
          ];
          let isTrue = false;
          let allClose = true;
          let errorTip = "";
          let iTimes = 0;
          regularArr.forEach((item) => {
            if (item.isOpen) {
              errorTip = errorTip + item.keyWord + "、";
              iTimes++;
              allClose = false;
            } else {
              isTrue = isTrue || value.search(item.search) > -1;
            }
          });
          if (iTimes > 0) {
            errorTip = errorTip.substring(0, errorTip.length - 1);
            errorTip = this.$t("onlyEnter") + `${errorTip}`;
          }
          if (!isTrue || allClose) {
            if (value.length > ev.maxInput && ev.maxInput > 0) {
              callback(this.$t("lengthNotExceed") + `${ev.maxInput}`);
            } else {
              callback();
            }
          } else {
            callback(errorTip);
          }
        };
      });
      this.leaveMessageConfigList = configList;
      this.$emit("isShow", true);
    },
    // 获得留言配置
    getConfig() {
      let params = {
        tenantId: this.visitorInfo.tenantId,
        enable: 1,
        lang: this.lang,
      };
      ajax
        .get(apis.leaveMessage.configList, {
          params,
        })
        .then((res) => {
          if (res.success) {
            this.setConfigList(res.data.leaveMessageConfigList);
            let formListObj = res.data && res.data.leaveMessageFormConfigList;
            this.leaveMessageFormConfigList = formListObj.filter((item) => {
              return item.configCode == "message_title";
            });
            window.top.document.title = this.leaveMessageFormConfigList[0]
              .finalValue
              ? this.leaveMessageFormConfigList[0].finalValue
              : this.leaveMessageFormConfigList[0].defaultValue;
          }
        });
    },
    // 提交留言配置
    sureSubmit(values) {
      let request = [];
      this.leaveMessageConfigList.forEach((ev) => {
        let fieldValue = values[ev.key];
        if (ev.fieldType == 2) {
          // 多选框
          fieldValue = fieldValue.length > 0 ? fieldValue.join(",") : "";
        }
        let obj = {
          fieldName: ev.fieldName,
          fieldId: ev.id, // 国际化用
          fieldValue: fieldValue,
        };
        request.push(obj);
      });
      let params = {
        detailList: request,
        leaveMessageRecord: {
          channelId: this.visitorInfo.typeId || this.visitorInfo.channelId,
          channelName:
            this.visitorInfo.typeName || this.visitorInfo.channelName,
          chatUserId: this.visitorInfo.visitorId,
          chatUserName: this.visitorInfo.visitorName,
          dealCustomerId: this.visitorInfo.agentId,
          skillId: this.visitorInfo.groupId || this.visitorInfo.skillId,
          skillName: this.visitorInfo.groupName || this.visitorInfo.skillName,
          sourceId: this.visitorInfo.channelCode || this.visitorInfo.sourceId,
          sourceName:
            this.visitorInfo.channelName || this.visitorInfo.sourceName,
          webId: this.visitorInfo.tenantId,
          leaveType: this.leaveType,
          platformId: this.visitorInfo.platformId,
        },
        webId: this.visitorInfo.tenantId,
        robotId: this.visitorInfo.robotId,
        robotNodeId: this.visitorInfo.robotNodeId,
        lang: this.lang,
      };
      this.btnLoading = true;
      this.$emit("btnLoading", true);
      ajax
        .post(apis.leaveMessage.saveLeave, params)
        .then((res) => {
          this.btnLoading = false;
          this.$emit("btnLoading", false);
          if (res.success) {
            this.$message.success(res.message);
            if (!this.isCloseWindow) {
              window.opener = null;
              window.open("", "_self");
              window.close();
            }
            this.$emit("isShow", false);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.btnLoading = false;
          this.$emit("btnLoading", false);
        });
    },
  },
  created() {
    let param = this.$route.query;
    this.lang = param.lang ? param.lang : this.lang;
    this.$i18n.locale = this.lang;
  },
  mounted() {
    this.getConfig();
  },
};
</script>
